import "../../styles/variabales.scss";
import "./addReferenceNumPage.scss";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import BookingInfoCompo from "../../components/BookingInfoCompo/BookingInfoCompo";
import AllServices from "../../Services/AllServices";
import CustomLoader from "../../components/CustomLoader/CustomLoader";
import Btton from "../../components/Start-Btn/StartBtn";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import { status } from "../../Constants/Constants";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const AddReferenceNumPage = () => {
  const [isOpenModel, setIsOpenModel] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const [btndisabled, setBtndisabled] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refId = params.get("refId");
    if (refId) {
      setReferenceNumber(refId);
      setBtndisabled(true);
    }

    const moreInfoParam = params.get("moreInfo");
    if (moreInfoParam) {
      try {
        const moreInfo = JSON.parse(decodeURIComponent(moreInfoParam));
        if (moreInfo) {
          const rId = moreInfo.referenceNumber || moreInfo.Refference_Number;
          if (rId) {
            setReferenceNumber(rId);
            setIsOpenModel(true);
            const checkStatus = moreInfo.status || moreInfo.Status;
            if (checkStatus === status.confirm) {
              setBtndisabled(true);
            } else {
              setBtndisabled(false);
            }
          }
        }
      } catch (error) {
        console.error("Failed to parse moreInfo from URL:", error);
      }
    }
  }, [location]);

  const handleChange = (event) => {
    setReferenceNumber(event.target.value);
  };

  const fetchDetails = async () => {
    if (!referenceNumber) {
      setLoading(false);
      toast.error("Please enter a Reference Number");
      return;
    }
    try {
      setLoading(true);
      var response = await AllServices.getReferences(referenceNumber);

      if (response?.data?.succuss) {
        setIsOpenModel(true);
        setBookingData(response);
        setBtndisabled(true);

        let checkStatus = response.data.message.Status;
        if (checkStatus === status.confirm) {
          setBtndisabled(true);
        } else {
          setBtndisabled(false);
        }
      } else {
        toast.error(response?.data?.message || "Something went wrong");
        setIsOpenModel(false);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Server error. Please try again";

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setIsOpenModel(false);
  };

  return (
    <div className="containor-addreference">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}
      <div className="wrapper-addreference">
        <div className="top-section">
          <h1 className="heading" style={{ fontFamily: "Roboto" }}>
            Find Your Reservation
          </h1>
          <div className="divider" />
          <p className="subtitle" style={{ fontFamily: "Roboto" }}>
            Enter your booking reference number to verify your details and begin
            checking in.
          </p>
        </div>

        <TextField
          className="textField"
          id="outlined-basic"
          type="text"
          label="Booking Reference Number"
          variant="outlined"
          value={referenceNumber}
          onChange={handleChange}
          disabled={btndisabled}
        />

        {!isOpenModel && !btndisabled && (
          <div className="info-box">
            <InfoIcon className="info-icon" />
            <p style={{ fontFamily: "Roboto" }}>
              Your booking reference number can be found in your reservation
              confirmation email.
            </p>
          </div>
        )}

        {btndisabled && (
          <div className="warning-box">
            <WarningAmberIcon className="warning-icon" />
            <p style={{ fontFamily: "Roboto" }}>
              This reservation has already been confirmed. If you need to update
              any details, please contact front desk support.
            </p>
          </div>
        )}

        {!isOpenModel && <Btton name="Start Now" onClick={fetchDetails} />}

        <div className="bottom">
          {isOpenModel && (
            <BookingInfoCompo
              onClose={handleClose}
              onResponse={bookingData}
              btnDisbled={btndisabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddReferenceNumPage;
